import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

export interface ApprovalConfigOption {
  id: number;
  name: string;
}

export interface ApprovalModuleOption extends ApprovalConfigOption {
  iconId: string | null;
}

export interface PreviousRevisionsModule {
  id: number;
  name: string;
}

/**
 * Feature-local on purpose: the existing clients for these endpoints live under `pages/`, which
 * a feature cannot import, and an `entities/` slice used by one feature trips steiger's
 * `fsd/insignificant-slice`.
 */
export const approvalConfigApi = {
  listModules: async (): Promise<ApprovalModuleOption[]> => {
    const response = await api.get<ApiResponse<ApprovalModuleOption[]>>('/modules');

    return response.data.data ?? [];
  },

  listRecordOrigins: async (): Promise<ApprovalConfigOption[]> => {
    const response = await api.get<ApiResponse<ApprovalConfigOption[]>>('/record-origins');

    return response.data.data ?? [];
  },

  listRecordTypes: async (recordOriginId: number): Promise<ApprovalConfigOption[]> => {
    const response = await api.get<ApiResponse<ApprovalConfigOption[]>>('/record-types', {
      params: { recordOriginId },
    });

    return response.data.data ?? [];
  },

  /** The module of the newest homologated revision of the RQ; null for a first revision. */
  getPreviousRevisionsModule: async (prefix: string): Promise<PreviousRevisionsModule | null> => {
    const response = await api.get<ApiResponse<{ module: PreviousRevisionsModule | null }>>(
      '/matrices/previous-revisions-module',
      { params: { prefix } }
    );

    return response.data.data?.module ?? null;
  },
};
